import type { TranscriptItem } from '../types/visual.js'

interface CachedDiscoveryReportPreview {
  sessionId: string
  htmlContent: string
  reportItem: TranscriptItem
}

let cachedReport: CachedDiscoveryReportPreview | null = null

export function cachePreparedDiscoveryReport(entry: CachedDiscoveryReportPreview): void {
  cachedReport = entry
}

export function clearCachedDiscoveryReport(): void {
  cachedReport = null
}

export function peekCachedDiscoveryReport(sessionId: string): CachedDiscoveryReportPreview | null {
  if (!cachedReport || cachedReport.sessionId !== sessionId) return null
  return cachedReport
}

/** Rehydrate a discovery_report card wiped by projection transcript (no attachments). */
export function mergeCachedDiscoveryReportIntoTranscript(
  sessionId: string,
  transcript: TranscriptItem[],
): TranscriptItem[] {
  const cached = peekCachedDiscoveryReport(sessionId)
  if (!cached) return transcript
  if (transcript.some(item => item.attachment?.type === 'discovery_report')) return transcript
  return [...transcript, cached.reportItem]
}
